import { FilterItem, FilterTypes } from '@shared/models/filters';
import { appDatePresets, appStrings } from '../../../app.config';

export const QUOTE_FILTERS: FilterItem[] = [
  {
    id: 'filter_serviceUuids',
    name: 'Services',
    description: appStrings.filters.filter_based_on_services,
    icon: 'ate-tag-v2',
    type: FilterTypes.SELECT_MULTIPLE,
    active: true,
    options: [],
    options_selected: 0,
    filters_applied_message: 'All',
    data: null
  },
  {
    id: 'filter_distance',
    name: 'Distance from event',
    description: appStrings.filters.filter_based_on_location,
    icon: 'ate-location-pin-v2',
    type: FilterTypes.SELECT_SINGLE,
    active: true,
    options: [],
    options_selected: 0,
    filters_applied_message: 'Any',
    data: null
  },
  {
    id: 'filter_dates',
    name: 'Date of event',
    description: null,
    icon: 'ate-calendar-v2',
    type: FilterTypes.DATERANGE_PICKER,
    active: true,
    options: appDatePresets,
    options_selected: 0,
    filters_applied_message: 'Any',
    data: null,
    min_date: new Date()
  },
  {
    id: 'filter_search',
    name: 'Search',
    type: FilterTypes.SEARCH,
    active: false,
    options: null,
    options_selected: 0,
    value: ''
  }
];
